import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import img from '../images/logo1.svg';

const Splash = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();

    useEffect(() => {
        const timer1 = setTimeout(() => setStep(2), 2000);
        const timer2 = setTimeout(() => {
            // Navigate to splash1 route instead of rendering component
            navigate('/splash1');
        }, 4000);
        
        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, [navigate]);

    const renderSplashContent = () => {
        switch(step) {
            case 1:
                return (
                    <div className='splashnew-container splash-bg1'>
                        <div className='splashnew_logo'>
                            <h2>Metabolytics</h2>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className='splashnew-container splash-bg2'>
                        <div className='splashnew-heading'>
                            <div className='splashnew_logo1'>
                                <img src={img} alt="Metabolytics Logo" />
                            </div>
                            <h2>Metabolytics</h2>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return renderSplashContent();
};

export default Splash;